import React, { useEffect, useState } from 'react';
import { StripeProvider } from 'react-stripe-elements';
import { getStripePromise } from 'utils/stripe.util';

// Loads Stripe.js only once a page that actually takes payment mounts,
// instead of on every page load - see public/index.html for why that
// matters (Stripe.js creates full-viewport iframes as a side effect of
// loading, which have no business existing on pages with no payment UI).
const WithStripe = ({ children }) => {
  const [stripe, setStripe] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getStripePromise().then(instance => {
      if (!cancelled) setStripe(instance);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  // react-stripe-elements renders fine with stripe: null - Elements/*Element
  // components just aren't interactive until it resolves, which is near
  // -instant since the script is small and often already cached.
  return <StripeProvider stripe={stripe}>{children}</StripeProvider>;
};

export default WithStripe;
